import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Button,
  Typography,
  Input,
  Chip,
  Switch,
  Dialog,
  DialogContent,
  Icon,
  withStyles,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tabs,
  Tab,
} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import AppState from '../../state';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { Utils } from '../../services';
import moment from 'moment';
import CurrencyInput from '../../components/lib/CurrencyInput';

import * as funcionarioAPI from '../../api/funcionarios';

const BigChip = withStyles({
  deleteIcon: {
    position: 'absolute',
    right: '0',
  },
})(Chip);

const styles = {
  halfGrid: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    width: '100%',
    maxWidth: '100%',
    flexBasis: 'auto',
  },
  modalButton: {
    marginTop: 10,
    fontSize: '0.875rem',
    backgroundColor: '#3f51b5',
    color: 'white',
    fontWeight: 'bold',
    border: '1px solid #3f51b5',
    '&:hover': {
      backgroundColor: '#303f9f',
      color: 'white',
    },
  },
  actionCell: {
    width: '50px',
  },
};

const CPFMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

const CPFMaskCustomEdit = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\w/,
        /\w/,
        /\w/,
        /\w/,
        /\w/,
      ]}
      guide={false}
    />
  );
};

const CurrencyMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  const numberMask = createNumberMask({
    prefix: 'R$ ',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: false,
  });

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={numberMask}
      guide={false}
    />
  );
};

const DateMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const CelMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        '(',
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={true}
    />
  );
};

const TelMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        '(',
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={true}
    />
  );
};

const CEPMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const UFMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/]}
      guide={false}
    />
  );
};

const RGMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\w/]}
      guide={false}
    />
  );
};

const ElevenDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const NineDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const FourDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

CPFMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CPFMaskCustomEdit.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

DateMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CelMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TelMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CEPMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

UFMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

RGMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

ElevenDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

NineDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

FourDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.documentoInput = React.createRef();

    this.state = {
      edicao: false,
      cpf: '',
      cpfErro: false,
      nome: '',
      nomeErro: false,
      emailPessoal: '',
      emailPessoalErro: false,
      emailProfissional: '',
      emailProfissionalErro: false,
      tipoVinculoList: [],
      tipoVinculo: '',
      tipoVinculoErro: false,
      jornadaTrabalho: '',
      jornadaTrabalhoErro: false,
      dataDesligamento: '',
      dataDesligamentoErro: false,
      sexo: '',
      exclusivo: '',
      projectList: [],
      project: '',
      projectErro: false,
      projetos: [],
      projetosErro: false,
      celular: '',
      telefone: '',
      telefoneErro: false,
      cep: '',
      cepErro: false,
      endereco: '',
      enderecoErro: false,
      numeroEndereco: '',
      numeroEnderecoErro: false,
      complemento: '',
      bairro: '',
      bairroErro: false,
      cidade: '',
      cidadeErro: false,
      uf: '',
      ufErro: false,
      trabalhaEscritorio: 'true',
      criaUsuarioSistema: '',
      perfil: '',
      perfilList: [],
      perfilErro: false,
      matricula: '',
      matriculaErro: false,
      custoMensal: '',
      custoMensalErro: false,
      isActive: this.dataDesligamento == null || this.dataDesligamento == '',
      cargo: '',
      cargoErro: false,
      dtAdmissao: moment().format('DD/MM/YYYY'),
      documentacao: [],
      linkDocumento: '',
      openHistoricoSalarial: false,
      openAlterarSalario: false,
      salarioAtual: '',
      motivoAlteracao: '',
      historicoSalarial: [],
      ultimaAlteracaoSalario: false,
      openBeneficios: false,
      valorAlimentacao: '',
      valorRefeicao: '',
      valorTransporte: '',
      valorPlanoSaude: '',
      historicoBeneficios: [],
      tabIndex: 0,
      showBeneficios: false,
      savedBeneficios: {
        valorAlimentacao: '',
        valorRefeicao: '',
        valorTransporte: '',
        valorPlanoSaude: '',
      },
      nomeMae: '',
      nomePai: '',
      nacionalidade: '',
      rg: '',
      estadoCivil: '',
      cidadeNascimento: '',
      cnhCategoria: [],
      cnhDtEmissao: '',
      cnhDtVencimento: '',
      cnhNumero: '',
      ctpsNumero: '',
      ctpsSerie: '',
      pisNumero: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleOpenHistoricoSalarial = () => {
    this.setState({ openHistoricoSalarial: true });
  };

  handleCloseHistoricoSalarial = () => {
    const { custoMensal, historicoSalarial } = this.state;
    if (historicoSalarial.length === 0) {
      this.setState({ custoMensalOriginal: custoMensal });
    }
    this.setState({ openHistoricoSalarial: false });
  };

  handleOpenAlterarSalario = () => {
    this.setState({
      openAlterarSalario: true,
      salarioAtual: '',
      motivoAlteracao: '',
    });
  };

  handleCloseAlterarSalario = () => {
    this.setState({ openAlterarSalario: false });
  };

  handleSalarioChange = (event) => {
    const salarioAtual = event.target.value;
    this.setState({ salarioAtual });
  };

  handleMotivoChange = (event) => {
    if (event.target.value.length <= 32) {
      this.setState({ motivoAlteracao: event.target.value });
    }
  };

  handleSaveSalario = () => {
    const { salarioAtual, motivoAlteracao, historicoSalarial, custoMensal } = this.state;

    if (!salarioAtual || !motivoAlteracao) {
      alert('Preenchimento obrigatório dos campos.');
      return;
    }

    const salarioAtualFloat = parseFloat(salarioAtual.replace(/[^\d,-]/g, '').replace(',', '.'));
    const novoHistorico = {
      salarioAnterior: `R$ ${custoMensal.toFixed(2).replace('.', ',')}`,
      salarioAtual: `R$ ${salarioAtualFloat.toFixed(2).replace('.', ',')}`,
      motivo: motivoAlteracao,
    };

    this.setState({
      custoMensal: salarioAtualFloat,
      historicoSalarial: [...historicoSalarial, novoHistorico],
      openAlterarSalario: false,
      ultimaAlteracaoSalario: true,
    }, () => {
      this.setState({ custoMensal: salarioAtualFloat });
    });
  };

  handleDeleteHistoricoSalarial = (index) => {
    const { historicoSalarial, custoMensalOriginal } = this.state;
    if (index === historicoSalarial.length - 1) {
      const updatedHistorico = historicoSalarial.filter((_, i) => i !== index);
      const ultimoHistorico = updatedHistorico[updatedHistorico.length - 1];
      const custoMensal = ultimoHistorico ? parseFloat(ultimoHistorico.salarioAtual.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) : custoMensalOriginal;
      this.setState({ historicoSalarial: updatedHistorico, custoMensal, ultimaAlteracaoSalario: false });
    }
  };

  handleOpenBeneficios = () => {
    this.setState({
      openBeneficios: true,
      valorAlimentacao: '',
      valorRefeicao: '',
      valorTransporte: '',
      valorPlanoSaude: '',
    });
  };

  handleCloseBeneficios = () => {
    this.setState({ openBeneficios: false });
  };

  handleBeneficioChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSaveBeneficios = () => {
    const { valorAlimentacao, valorRefeicao, valorTransporte, valorPlanoSaude } = this.state;

    if (!valorAlimentacao && !valorRefeicao && !valorTransporte && !valorPlanoSaude) {
      alert('Por favor, preencha todos os campos antes de salvar.');
      return;
    }

    const novoHistorico = {
      valorAlimentacao: valorAlimentacao || this.state.savedBeneficios.valorAlimentacao,
      valorRefeicao: valorRefeicao || this.state.savedBeneficios.valorRefeicao,
      valorTransporte: valorTransporte || this.state.savedBeneficios.valorTransporte,
      valorPlanoSaude: valorPlanoSaude || this.state.savedBeneficios.valorPlanoSaude,
      data: new Date().toLocaleString(),
    };

    this.setState({
      historicoBeneficios: [...this.state.historicoBeneficios, novoHistorico],
      showBeneficios: true,
      savedBeneficios: novoHistorico,
    });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  componentDidMount() {
    this.getTipoVinculo();
    this.getProjetos();
    this.getPerfis();
    this.setState({ custoMensalOriginal: this.state.custoMensal });

    this.setState({ ultimaAlteracaoSalario: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.edicao !== this.props.edicao) {
      this.setState(
        {
          edicao: this.props.edicao,
          isActive:
            this.dataDesligamento == null || this.dataDesligamento == '',
        },
        () => {
          if (this.props.edicao) {
            this.getFuncionarioData();
          } else {
            this.setState({
              valorAlimentacao: '',
              valorRefeicao: '',
              valorTransporte: '',
              valorPlanoSaude: '',
              savedBeneficios: {
                valorAlimentacao: '',
                valorRefeicao: '',
                valorTransporte: '',
                valorPlanoSaude: '',
              },
              showBeneficios: false,
            });
          }
        }
      );
    }
  }

  getTipoVinculo = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/funcionarios/GetTipoVinculoList.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          tipoVinculoList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          alert('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else alert('Dados inválidos');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          alert('Erro desconhecido, tente novamente');
        }
      });
  };

  getProjetos = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/projetos/GetProjects.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          projectList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          alert('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else alert('Erro ao processar, por favor tente novamente');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          alert('Erro desconhecido, tente novamente');
        }
      });
  };

  getPerfis = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/comum/GetPerfisAcesso.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          perfilList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          alert('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else alert('Erro ao processar, por favor tente novamente');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          alert('Erro desconhecido, tente novamente');
        }
      });
  };

  getFuncionarioData = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/funcionarios/GetFuncionario.php?json={"cpf_funcionario":"${this.props.funcionario}"}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          return response.json();
        }
      })
      .then((response) => {
        AppState.isLoading = false;

        const linkDocumentacao = JSON.parse(response.request[0].link_documentacao) || [];
        const documentacaoArray = linkDocumentacao
          .filter(link => link && link.trim() !== '')
          .map((link) => {
            const nomeArquivo = link.split('/').pop();
            return { name: nomeArquivo, link };
          });

        const historicoSalarial = response.request[0].salarios.map((item) => ({
          salarioAnterior: `R$ ${parseFloat(item.salario_anterior).toFixed(2).replace('.', ',')}`,
          salarioAtual: `R$ ${parseFloat(item.salario_atual).toFixed(2).replace('.', ',')}`,
          motivo: item.motivo,
        })) || [];

        const beneficiosData = response.request[0].beneficios;
        let beneficios = { vale_alimentacao: "0.00", vale_refeicao: "0.00", vale_transporte: "0.00", plano_saude: "0.00" };
        if (beneficiosData && Array.isArray(beneficiosData) && beneficiosData.length > 0) {
          beneficios = beneficiosData[0];
        }

        const formatCurrency = (value) => {
          const number = parseFloat(value);
          return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };



        const savedBenefits = {
          valorAlimentacao: formatCurrency(beneficios.vale_alimentacao || 0),
          valorRefeicao: formatCurrency(beneficios.vale_refeicao || 0),
          valorTransporte: formatCurrency(beneficios.vale_transporte || 0),
          valorPlanoSaude: formatCurrency(beneficios.plano_saude || 0),
        };



        const hasBenefits =
          parseFloat(savedBenefits.valorAlimentacao) > 0 ||
          parseFloat(savedBenefits.valorRefeicao) > 0 ||
          parseFloat(savedBenefits.valorTransporte) > 0 ||
          parseFloat(savedBenefits.valorPlanoSaude) > 0;

        this.setState({
          nome: response.request[0].nome_funcionario || '',
          matricula: response.request[0].matricula_funcionario || '',
          cpf: response.request[0].cpf_funcionario || '',
          sexo: response.request[0].sexo || '',
          bairro: response.request[0].bairro_residencia || '',
          celular: response.request[0].celular || '',
          telefone: response.request[0].tel_residencia || '',
          emailPessoal: response.request[0].email_pessoal || '',
          emailProfissional: response.request[0].email_profissional || '',
          dtAdmissao: Utils.dateToPT(response.request[0].dt_admissao),
          dataDesligamento: Utils.dateToPT(response.request[0].dt_demissao),
          dataNascimento: Utils.dateToPT(response.request[0].dt_nascimento),
          uf: response.request[0].uf_residencia || '',
          cep: response.request[0].cep_residencia || '',
          endereco: response.request[0].end_residencia || '',
          numeroEndereco: response.request[0].numero_residencia || '',
          complemento: response.request[0].complemento_residencia || '',
          cidade: response.request[0].cidade_residencia || '',
          cidade_nascimento: response.request[0].cidade_nascimento || '',
          tipoVinculo: response.request[0].tipo_vinculo || '',
          jornadaTrabalho: response.request[0].jornada_diaria_trabalho || '',
          custoMensal: parseFloat(response.request[0].custo_total_mensal),
          isActive: response.request[0].dt_demissao === null,
          cargo: response.request[0].cargo || '',
          linkDocumento: response.request[0].link_documentacao || '',
          documentacao: documentacaoArray,
          historicoSalarial: historicoSalarial,
          ultimaAlteracaoSalario: false,
          valorAlimentacao: savedBenefits.valorAlimentacao,
          valorRefeicao: savedBenefits.valorRefeicao,
          valorTransporte: savedBenefits.valorTransporte,
          valorPlanoSaude: savedBenefits.valorPlanoSaude,
          savedBeneficios: savedBenefits,
          showBeneficios: hasBenefits,
          nomeMae: response.request[0].nome_mae || '',
          nomePai: response.request[0].nome_pai || '',
          nacionalidade: response.request[0].nacionalidade || '',
          rg: response.request[0].rg_numero || '',
          estadoCivil: response.request[0].estado_civil || '',
          perfil: response.request[0].perfil || '',
          cnhCategoria: response.request[0].cnh_categoria ? response.request[0].cnh_categoria.split(',').map(c => c.trim()) : [],
          cnhDtEmissao: Utils.dateToPT(response.request[0].cnh_dt_emissao),
          cnhDtVencimento: Utils.dateToPT(response.request[0].cnh_dt_vencimento),
          cnhNumero: response.request[0].cnh_numero || '',
          ctpsNumero: response.request[0].ctps_numero || '',
          ctpsSerie: response.request[0].ctps_serie || '',
          pisNumero: response.request[0].pis_numero || '',
        });
      })
      .catch((error) => {
        AppState.isLoading = false;
        console.error('Erro ao buscar dados do funcionário:', error);
      });
  };



  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  statusHandleChange = (event) => {
    if (event.target.checked) {
      this.setState({
        isActive: event.target.checked,
        dataDesligamento: '',
      });
    } else {
      this.setState({
        isActive: event.target.checked,
        dataDesligamento: Utils.dateToPT(
          new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 10)
        ),
      });
    }
  };

  projetosHandleChange = (event) => {
    if (event.target.value && event.target.value.length > 0) {
      this.setState({
        projetos: event.target.value,
      });
    }
  };

  exclusivoHandleChange = (event) => {
    this.setState({
      project: '',
      projetos: [],
      exclusivo: event.target.value,
    });
  };

  closeDialog = () => {
    this.setState(
      {
        edicao: false,
        cpf: '',
        cpfErro: false,
        nome: '',
        nomeErro: false,
        emailPessoal: '',
        emailPessoalErro: false,
        emailProfissional: '',
        emailProfissionalErro: false,
        tipoVinculo: '',
        tipoVinculoErro: false,
        jornadaTrabalho: '',
        jornadaTrabalhoErro: false,
        dataDesligamento: '',
        dataDesligamentoErro: false,
        sexo: '',
        exclusivo: '',
        project: '',
        projectErro: false,
        projetos: [],
        projetosErro: false,
        celular: '',
        telefone: '',
        telefoneErro: false,
        cep: '',
        cargo: '',
        cargoErro: false,
        cepErro: false,
        endereco: '',
        enderecoErro: false,
        numeroEndereco: '',
        numeroEnderecoErro: false,
        complemento: '',
        cidade: '',
        bairro: '',
        bairroErro: false,
        cidadeErro: false,
        uf: '',
        ufErro: false,
        trabalhaEscritorio: 'true',
        criaUsuarioSistema: '',
        perfil: '',
        perfilErro: false,
        matricula: '',
        matriculaErro: false,
        custoMensal: '',
        custoMensalErro: false,
        dtAdmissao: moment().format('DD/MM/YYYY'),
        dtAdmissaoErro: false,
        documentacao: [],
        linkDocumento: '',
        valorAlimentacao: '',
        valorRefeicao: '',
        valorTransporte: '',
        valorPlanoSaude: '',
        savedBeneficios: {
          valorAlimentacao: '',
          valorRefeicao: '',
          valorTransporte: '',
          valorPlanoSaude: '',
        },
        historicoBeneficios: [],
        showBeneficios: false,
      },
      () => this.props.close()
    );
  };

  getEndereco = (cep) => {
    AppState.isLoading = true;
    fetch(`https://viacep.com.br/ws/${cep}/json/`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          endereco: response.logradouro,
          bairro: response.bairro,
          cidade: response.localidade,
          uf: response.uf,
        });

        if (response.erro == true) {
          this.setState({
            endereco: '',
            bairro: '',
            cidade: '',
            uf: '',
          });
        }
      });
  };


  addFuncionario = () => {
    AppState.isLoading = true;

    const data = JSON.stringify({
      cpf: this.state.cpf,
      nome: this.state.nome,
      matricula: this.state.matricula,
      sexo: this.state.sexo,
      email_pessoal: this.state.emailPessoal,
      email_profissional: this.state.emailProfissional,
      cel: this.state.celular,
      tel_residencia: this.state.telefone,
      tipo_vinculo: this.state.tipoVinculo,
      jornada_horas: this.state.jornadaTrabalho,
      custo_mensal: Utils.moeda2float(this.state.custoMensal),
      dt_admissao: Utils.dateToEN(this.state.dtAdmissao),
      dt_desligamento: Utils.dateToEN(this.state.dataDesligamento),
      dt_nascimento: Utils.dateToEN(this.state.dataNascimento),
      cep: this.state.cep,
      endereco: this.state.endereco,
      end_numero: this.state.numeroEndereco,
      end_bairro: this.state.bairro,
      end_complemento: this.state.complemento,
      cidade: this.state.cidade,
      uf: this.state.uf,
      perfil: this.state.perfil,
      projetos: this.state.projetos.length < 1 ? [{ id_projeto: this.state.project }] : this.state.projetos,
      ativo: 'true',
      exclusivo: this.state.exclusivo,
      cargo: this.state.cargo,
      beneficios: {
        vale_alimentacao: this.state.valorAlimentacao
          ? parseFloat(this.state.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        vale_refeicao: this.state.valorRefeicao
          ? parseFloat(this.state.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        vale_transporte: this.state.valorTransporte
          ? parseFloat(this.state.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        plano_saude: this.state.valorPlanoSaude
          ? parseFloat(this.state.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
      },
      nome_mae: this.state.nomeMae,
      nome_pai: this.state.nomePai,
      nacionalidade: this.state.nacionalidade,
      rg: this.state.rg,
      estado_civil: this.state.estadoCivil,
      cidade_nascimento: this.state.cidadeNascimento,
      cnh_categoria: Array.isArray(this.state.cnhCategoria) ? this.state.cnhCategoria.join(', ') : this.state.cnhCategoria,
      cnh_dt_emissao: Utils.dateToEN(this.state.cnhDtEmissao),
      cnh_dt_vencimento: Utils.dateToEN(this.state.cnhDtVencimento),
      cnh_numero: this.state.cnhNumero,
      ctpsNumero: this.state.ctpsNumero,
      ctpsSerie: this.state.ctpsSerie,
      pisNumero: this.state.pisNumero,
    });

    console.log('Dados do funcionário em JSON:', data);

    const documentacaoData = new FormData();
    documentacaoData.append('json', data);

    (this.state.documentacao || []).forEach((file, index) => {
      if (file && file.file) {
        documentacaoData.append(`file_${index}`, file.file);
      }
    });

    funcionarioAPI
      .addFuncionario(documentacaoData)
      .then((response) => {
        AppState.isLoading = false;
        this.props.carregaTabela();
        this.closeDialog();
      })
      .catch((error) => {
        AppState.isLoading = false;

        if (!error || !error.response || !error.response.data) {
          alert('Erro desconhecido, tente novamente.');
          return;
        }

        const errorData = error.response.data;
        const errCode = errorData.code;
        const errMessage = errorData.message || 'Erro desconhecido.';

        alert(errMessage);

        if (error.response.status === 401) {
          const logoutUrl =
            process.env.NODE_ENV === 'development'
              ? "http://localhost:3000/logout"
              : `${process.env.PUBLIC_URL}/logout`;
          window.location.href = logoutUrl;
        }
      });
  };



  editFuncionario = () => {
    AppState.isLoading = true;

    const validLinks = Array.isArray(this.state.documentacao)
      ? this.state.documentacao
        .filter((doc) => !doc.preview || doc.link)
        .map((doc) => doc.link || '')
      : [];

    const data = JSON.stringify({
      cpf: this.state.cpf,
      nome: this.state.nome,
      matricula: this.state.matricula,
      sexo: this.state.sexo,
      email_pessoal: this.state.emailPessoal,
      email_profissional: this.state.emailProfissional,
      cel: this.state.celular,
      tel_residencia: this.state.telefone,
      projeto_vinculado: this.state.project,
      tipo_vinculo: this.state.tipoVinculo,
      jornada_horas: this.state.jornadaTrabalho,
      custo_mensal: Utils.moeda2float(this.state.custoMensal),
      historico_salarial: this.state.ultimaAlteracaoSalario ? this.state.historicoSalarial.map((item) => ({
        salario_anterior: parseFloat(
          item.salarioAnterior.replace('R$ ', '').replace(',', '.')
        ),
        salario_atual: parseFloat(
          item.salarioAtual.replace('R$ ', '').replace(',', '.')
        ),
        motivo: item.motivo,
      })) : [],
      dt_admissao: Utils.dateToEN(this.state.dtAdmissao),
      dt_desligamento: Utils.dateToEN(this.state.dataDesligamento),
      dt_nascimento: Utils.dateToEN(this.state.dataNascimento),
      cep: this.state.cep,
      endereco: this.state.endereco,
      end_bairro: this.state.bairro,
      end_numero: this.state.numeroEndereco,
      end_complemento: this.state.complemento,
      cidade: this.state.cidade,
      uf: this.state.uf,
      perfil: this.state.perfil,
      projetos: this.state.projetos,
      cargo: this.state.cargo,
      link_documento: validLinks,
      beneficios: {
        vale_alimentacao: this.state.valorAlimentacao
          ? parseFloat(this.state.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        vale_refeicao: this.state.valorRefeicao
          ? parseFloat(this.state.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        vale_transporte: this.state.valorTransporte
          ? parseFloat(this.state.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        plano_saude: this.state.valorPlanoSaude
          ? parseFloat(this.state.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.')),
      },
      nome_mae: this.state.nomeMae,
      nome_pai: this.state.nomePai,
      nacionalidade: this.state.nacionalidade,
      rg: this.state.rg,
      estado_civil: this.state.estadoCivil,
      cidade_nascimento: this.state.cidadeNascimento,
      cnh_categoria: Array.isArray(this.state.cnhCategoria) ? this.state.cnhCategoria.join(', ') : this.state.cnhCategoria,
      cnh_dt_emissao: Utils.dateToEN(this.state.cnhDtEmissao),
      cnh_dt_vencimento: Utils.dateToEN(this.state.cnhDtVencimento),
      cnh_numero: this.state.cnhNumero,
      ctpsNumero: this.state.ctpsNumero,
      ctpsSerie: this.state.ctpsSerie,
      pisNumero: this.state.pisNumero,
    });

    console.log('Dados enviados ao backend:', data);

    const documentoData = new FormData();
    documentoData.append('json', data);

    (this.state.documentacao || []).forEach((doc, index) => {
      if (doc.file) {
        documentoData.append(`file_${index}`, doc.file);
      }
    });

    funcionarioAPI
      .editFuncionario(documentoData)
      .then((response) => {
        AppState.isLoading = false;
        this.props.carregaTabela();
        this.closeDialog();
      })
      .catch((error) => {
        AppState.isLoading = false;

        if (!error || !error.response || !error.response.status) {
          alert('Erro desconhecido, tente novamente.');
          return;
        }

        const Err_status = error.response.status;

        switch (Err_status) {
          case 400:
            const ret = error.response.data?.status?.value || '';
            if (['40001', '40002'].includes(ret)) {
              alert('Dados inválidos.');
            } else if (ret === '40003') {
              alert('Erro ao Atualizar Colaborador.');
            } else if (ret === '40004') {
              alert('Erro ao reativar colaborador.');
            } else if (ret === '40005') {
              alert('CPF já cadastrado como fornecedor.');
            } else if (ret === '40006') {
              alert('Já existe um usuário com este CPF.');
            } else if (ret === '40007') {
              alert('Usuário não encontrado.');
            } else {
              alert('Dados inválidos.');
            }
            break;

          case 401:
            if (process.env.NODE_ENV === 'development') {
              window.location.href = "http://localhost:3000/logout";
            } else {
              window.location.href = `${process.env.PUBLIC_URL}/logout`;
            }
            break;

          case 500:
          default:
            alert('Erro desconhecido, tente novamente.');
        }
      });
  };



  validaForm = () => {
    let formValido = true;

    if (!this.state.cpf || this.state.cpf == '' || this.state.cpf.length < 11) {
      formValido = false;
      this.setState({
        cpfErro: true,
      });
    }

    if (!this.state.nome || this.state.nome == '') {
      formValido = false;
      this.setState({
        nomeErro: true,
      });
    }

    if (this.state.tipoVinculo == '') {
      formValido = false;
      this.setState({
        tipoVinculoErro: true,
      });
    }

    if (this.state.cargo == '') {
      formValido = false;
      this.setState({
        cargoErro: true,
      });
    }

    if (this.state.matricula == '') {
      formValido = false;
      this.setState({
        matriculaErro: true,
      });
    }

    if (!this.state.emailProfissional || this.state.emailProfissional == '') {
      formValido = false;
      this.setState({
        emailProfissionalErro: true,
      });
    }

    if (this.state.jornadaTrabalho == '') {
      formValido = false;
      this.setState({
        jornadaTrabalhoErro: true,
      });
    }

    if (!this.state.custoMensal || this.state.custoMensal == '') {
      formValido = false;
      this.setState({
        custoMensalErro: true,
      });
    }

    if (this.state.cep == '' || this.state.cep.length < 9) {
      formValido = false;
      this.setState({
        cepErro: true,
      });
    }

    if (this.state.endereco == '') {
      formValido = false;
      this.setState({
        enderecoErro: true,
      });
    }

    if (this.state.bairro == '') {
      formValido = false;
      this.setState({
        bairroErro: true,
      });
    }

    if (this.state.numeroEndereco == '') {
      formValido = false;
      this.setState({
        numeroEnderecoErro: true,
      });
    }

    if (this.state.cidade == '') {
      formValido = false;
      this.setState({
        cidadeErro: true,
      });
    }

    if (this.state.uf == '' || this.state.uf.length != 2) {
      formValido = false;
      this.setState({
        ufErro: true,
      });
    }

    if (this.state.sexo == '') {
      formValido = false;
      alert('Por favor informe o sexo do colaborador.');
      this.setState({
        sexoErro: true,
      });
    }

    if (
      !this.state.dtAdmissao ||
      !moment(this.state.dtAdmissao, 'DD/MM/YYYY', true).isValid()
    ) {
      formValido = false;
      this.setState({
        dtAdmissaoErro: true,
      });
    }

    if (!this.state.edicao) {
      if (this.state.perfil == '') {
        formValido = false;
        this.setState({
          perfilErro: true,
        });
      }

      if (this.state.exclusivo == 'true') {
        if (this.state.project == '') {
          formValido = false;
          this.setState({
            projectErro: true,
          });
        }
      } else {
        if (this.state.projetos.length <= 0) {
          formValido = false;
          this.setState({
            projetosErro: true,
          });
        }
      }
    }

    if (formValido) {
      if (this.state.edicao) {
        this.editFuncionario();
      } else {
        this.addFuncionario();
      }
    }
  };

  CEPhandleChange = (event) => {
    this.setState(
      {
        cep: event.target.value,
      },
      () => {
        if (this.state.cep.length === 9) {
          this.getEndereco(this.state.cep.replace('-', ''));
        }
      }
    );
  };

  deleteDocumentacaoChip = (index) => {
    const arr = [...this.state.documentacao];
    arr.splice(index, 1);

    this.setState({
      documentacao: arr,
      linkDocumento: arr.length > 0 ? this.state.linkDocumento : null,
    });
  };

  handleDocumentacaoFile = (event) => {
    event.preventDefault();
    const files = Array.from(this.documentoInput.current.files);
    const tenMbInKb = 25000;

    const validFiles = files.filter((file) => {
      const sizeInKb = file.size / 1000;
      if (sizeInKb > tenMbInKb) {
        alert(`O arquivo ${file.name} deve ser inferior a 25MB.`);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {

      const filesWithPreview = validFiles.map((file) => ({
        name: file.name,
        size: file.size,
        file,
        preview: URL.createObjectURL(file),
      }));

      this.setState((prevState) => ({
        documentacao: [...(prevState.documentacao || []), ...filesWithPreview],
      }));
    }

    event.target.value = null;
  };



  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.closeDialog}
        fullWidth
        maxWidth="lg"
        disableBackdropClick={true}
        fullScreen
      >
        <DialogContent>
          <form id={this.constructor.name}>
            <Grid
              container={true}
              alignItems={'flex-start'}
              justify={'space-around'}
              direction={'row'}
              spacing={40}
            >
              <Grid
                item
                sm={10}
                container
                direction="row"
                justify="space-between"
                style={{ maxWidth: '100%', flexGrow: '1', flexBasis: 'auto', flexWrap: 'nowrap' }}
              >
                <Typography variant="h4">Cadastro de Colaboradores</Typography>
                <Icon onClick={this.closeDialog}>close</Icon>
              </Grid>

              <Grid item md={4} style={{ width: '100%' }}>
                <Typography variant="h6" style={{ marginBottom: '16px' }}>Dados Profissionais</Typography>
                <Grid container spacing={16}>
                  <Grid item md={5}>
                    <FormControl fullWidth={true}>
                      <TextField
                        label={'CPF'}
                        name={'cpf'}
                        onChange={this.handleChange}
                        value={this.state.cpf}
                        error={this.state.cpfErro}
                        InputProps={{
                          inputComponent: this.state.cpf.length > 14 ? CPFMaskCustomEdit : CPFMaskCustom,
                          readOnly: this.props.edicao,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={7} style={{ marginTop: '10px' }}>
                    <Switch
                      value={this.state.isActive}
                      disabled={this.state.edicao === false}
                      color={'primary'}
                      checked={this.state.isActive}
                      onChange={this.statusHandleChange}
                    />
                    <InputLabel>Colaborador {this.state.isActive ? 'Ativo' : 'Desligado'}</InputLabel>
                  </Grid>
                </Grid>

                <FormControl fullWidth={true}>
                  <TextField label={'Nome Completo'} name={'nome'} value={this.state.nome} onChange={this.handleChange} error={this.state.nomeErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="type_of_link">Tipo de Vínculo</InputLabel>
                      <Select value={this.state.tipoVinculo} inputProps={{ name: 'tipoVinculo' }} error={this.state.tipoVinculoErro} onChange={this.handleChange}>
                        {this.state.tipoVinculoList.map((item, index) => (
                          <MenuItem value={item.tipo_vinculo} key={index}>{item.tipo_vinculo}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth={true}>
                      <TextField label={'Matrícula'} name={'matricula'} value={this.state.matricula} onChange={this.handleChange} error={this.state.matriculaErro} />
                    </FormControl>
                  </Grid>
                </Grid>

                <FormControl fullWidth={true}>
                  <TextField type="text" label={'Cargo'} name={'cargo'} value={this.state.cargo} onChange={this.handleChange} error={this.state.cargoErro} />
                </FormControl>

                <FormControl fullWidth={true}>
                  <TextField type="email" label={'E-mail Profissional'} name={'emailProfissional'} value={this.state.emailProfissional} onChange={this.handleChange} error={this.state.emailProfissionalErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6}>
                    <FormControl fullWidth={true}>
                      <TextField label={'CTPS Número'} name={'ctpsNumero'} value={this.state.ctpsNumero} onChange={this.handleChange} error={this.state.ctpsNumeroErro} InputProps={{ inputComponent: ElevenDigitsMaskCustom }}/>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} >
                    <FormControl fullWidth={true}>
                      <TextField label={'CTPS Série'} name={'ctpsSerie'} value={this.state.ctpsSerie} onChange={this.handleChange} error={this.state.ctpsSerieErro} InputProps={{ inputComponent: FourDigitsMaskCustom }}/>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={16} style={{ marginTop: '2px' }}>
                  <Grid item md={this.state.isActive === false ? 6 : 12}>
                    <FormControl fullWidth={true}>
                      <TextField label={'Data de Início do Contrato'} value={this.state.dtAdmissao} name={'dtAdmissao'} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} error={this.state.dtAdmissaoErro} />
                    </FormControl>
                  </Grid>
                  {this.state.isActive === false && (
                    <Grid item md={6}>
                      <FormControl fullWidth={true}>
                        <TextField label={'Data de Desligamento'} value={this.state.dataDesligamento} name={'dataDesligamento'} InputProps={{ inputComponent: DateMaskCustom }} onChange={this.handleChange} error={this.state.dataDesligamentoErro} />
                      </FormControl>
                    </Grid>
                  )}
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="type_of_link">Horas Diárias</InputLabel>
                      <Select value={this.state.jornadaTrabalho} inputProps={{ name: 'jornadaTrabalho' }} error={this.state.jornadaTrabalhoErro} onChange={this.handleChange}>
                        {[2, 3, 4, 5, 6, 7, 8].map(h => <MenuItem value={h} key={h}>{`0${h} Horas Diárias`}</MenuItem>)}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth={true}>
                      <CurrencyInput label={'Custo Total Mensal'} name={'custoMensal'} value={this.state.custoMensal} onChange={this.handleChange} error={this.state.custoMensalErro} disabled={this.state.edicao} />
                    </FormControl>
                  </Grid>
                </Grid>

                {this.state.edicao && (
                  <React.Fragment>
                    <Grid container spacing={16} style={{ marginTop: '16px' }}>
                      <Grid item>
                        <Button
                          variant="contained"
                          onClick={this.handleOpenHistoricoSalarial}
                          style={styles.modalButton}
                        >
                          Histórico de Remuneração
                        </Button>
                      </Grid>
                    </Grid>

                    <Dialog
                      open={this.state.openHistoricoSalarial}
                      onClose={this.handleCloseHistoricoSalarial}
                      fullWidth
                      maxWidth="md"
                    >
                      <DialogContent style={{ overflowY: 'auto' }}>
                        <Typography variant="h6">Histórico de Remuneração</Typography>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Remuneração Anterior</TableCell>
                              <TableCell style={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Remuneração Atual</TableCell>
                              <TableCell style={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Motivo</TableCell>
                              <TableCell className={styles.actionCell}>Ações</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.historicoSalarial.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>{item.salarioAnterior}</TableCell>
                                <TableCell>{item.salarioAtual}</TableCell>
                                <TableCell>{item.motivo}</TableCell>
                                <TableCell className={styles.actionCell}>
                                  {index === this.state.historicoSalarial.length - 1 && this.state.ultimaAlteracaoSalario ? (
                                    <Icon onClick={() => this.handleDeleteHistoricoSalarial(index)}>close</Icon>
                                  ) : null}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <Button onClick={this.handleCloseHistoricoSalarial} style={styles.modalButton}>
                          Fechar
                        </Button>
                      </DialogContent>
                    </Dialog>
                  </React.Fragment>
                )}

                <FormControl>
                  <FormLabel style={{ display: 'inline-block', marginTop: '16px' }}>Sexo</FormLabel>
                  <RadioGroup name="sexo" row={true} value={this.state.sexo} onChange={this.handleChange}>
                    <FormControlLabel value="M" control={<Radio color={'primary'} />} label="Masculino" />
                    <FormControlLabel value="F" control={<Radio color={'primary'} />} label="Feminino" />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item md={4} style={{ width: '100%' }}>
              <Typography variant="h6" style={{ marginBottom: '16px' }}>Dados Pessoais</Typography>
                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'Nome Mãe'} name={'nomeMae'} value={this.state.nomeMae} onChange={this.handleChange} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'Nome Pai'} name={'nomePai'} value={this.state.nomePai} onChange={this.handleChange} /></Grid>
                </Grid>
                
                <Grid container spacing={16}>
                  <Grid item md={4}>
                    <FormControl fullWidth={true}>
                    <InputLabel>Estado Civil</InputLabel>
                      <Select value={this.state.estadoCivil} onChange={this.handleChange} inputProps={{ name: 'estadoCivil' }}>
                        <MenuItem value="Solteiro(a)">Solteiro(a)</MenuItem>
                        <MenuItem value="Casado(a)">Casado(a)</MenuItem>
                        <MenuItem value="Divorciado(a)">Divorciado(a)</MenuItem>
                        <MenuItem value="Viúvo(a)">Viúvo(a)</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4}><TextField fullWidth label={'Nacionalidade'} name={'nacionalidade'} value={this.state.nacionalidade} onChange={this.handleChange} /></Grid>
                  <Grid item md={4}><TextField fullWidth label={'PIS'} name={'pisNumero'} value={this.state.pisNumero} onChange={this.handleChange} InputProps={{ inputComponent: ElevenDigitsMaskCustom }}/></Grid>
                </Grid>

                <Grid item md={16}><TextField fullWidth label={'RG'} name={'rg'} value={this.state.rg} onChange={this.handleChange} InputProps={{ inputComponent: RGMaskCustom }}/></Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'Cidade Nasc.'} name={'cidadeNascimento'} value={this.state.cidadeNascimento} onChange={this.handleChange} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'Data Nascimento'} name={'dataNascimento'} value={this.state.dataNascimento} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'CNH Número'} name={'cnhNumero'} value={this.state.cnhNumero} onChange={this.handleChange} InputProps={{ inputComponent: NineDigitsMaskCustom }}/></Grid>
                  <Grid item md={6}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="cnhCategoria">CNH Categoria</InputLabel>
                      <Select multiple value={this.state.cnhCategoria} inputProps={{ name: 'cnhCategoria' }} onChange={this.handleChange} renderValue={(selected) => selected.join(', ')}>
                        <MenuItem value="A">A</MenuItem>
                        <MenuItem value="B">B</MenuItem>
                        <MenuItem value="C">C</MenuItem>
                        <MenuItem value="D">D</MenuItem>
                        <MenuItem value="E">E</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={16}>  
                  <Grid item md={6}><TextField fullWidth label={'CNH Data Emissão'} name={'cnhDtEmissao'} value={this.state.cnhDtEmissao} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'CNH Data Vencimento'} name={'cnhDtVencimento'} value={this.state.cnhDtVencimento} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>  
                </Grid>

              </Grid>

              <Grid item md={4} style={{ width: '100%' }}>
                {!this.state.edicao && (
                  <React.Fragment>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="profile">Perfil</InputLabel>
                      <Select value={this.state.perfil} inputProps={{ name: 'perfil' }} error={this.state.perfilErro} onChange={this.handleChange}>
                        {this.state.perfilList.map((item) => <MenuItem key={item.id_perfil} value={item.id_perfil}>{item.desc_perfil}</MenuItem>)}
                      </Select>
                    </FormControl>
                    <FormControl component="fieldset" style={{ marginTop: '16px' }}>
                      <FormLabel>Colaborador exclusivo de um projeto?</FormLabel>
                      <RadioGroup name="exclusivo" row={true} value={this.state.exclusivo} onChange={this.exclusivoHandleChange}>
                        <FormControlLabel value={'true'} control={<Radio color={'primary'} />} label="Sim" />
                        <FormControlLabel value={'false'} control={<Radio color={'primary'} />} label="Não" />
                      </RadioGroup>
                    </FormControl>
                  </React.Fragment>
                )}

                {this.state.exclusivo == 'true' && (
                  <FormControl fullWidth={true}>
                    <InputLabel htmlFor="projetos">Selecione o Projeto</InputLabel>
                    <Select error={this.state.projectErro} value={this.state.project} inputProps={{ name: 'project' }} onChange={this.handleChange}>
                      {this.state.projectList.map((item) => <MenuItem key={item.id_projeto} value={item.id_projeto}>{item.display}</MenuItem>)}
                    </Select>
                  </FormControl>
                )}

                <InputLabel style={{ fontSize: '18px', display: 'block', marginTop: '8px' }}>Documentos</InputLabel>
                <label htmlFor="outlined-contrato-file" style={{ width: '100%', marginTop: '8px' }}>
                  <input id="outlined-contrato-file" type="file" style={{ display: 'none' }} ref={this.documentoInput} onChange={this.handleDocumentacaoFile} multiple />
                  <Button variant="outlined" component="span" fullWidth={true}>Anexar Documentação</Button>
                </label>
                {this.state.documentacao.map((item, index) => {
                    const fileName = item.name && item.name.trim() !== '' ? item.name : `Documento Anexado ${index + 1}`;
                    const fileUrl = item.preview || item.link;

                    return (
                        <Chip 
                            key={index} 
                            label={fileName} 
                            onClick={() => window.open(fileUrl, "_blank")}
                            onDelete={() => this.deleteDocumentacaoChip(index)} 
                            color="primary"
                            variant="outlined"
                            style={{ 
                                marginTop: '8px', 
                                width: '100%', 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                cursor: 'pointer' 
                            }} 
                        />
                    );
                })}
                
                

                <Typography variant="h6" style={{ marginTop: '20px' }}>Informações Sistema</Typography>
                <TextField fullWidth label={'Projeto Atual'} value={this.state.project} disabled={true} style={{ cursor: 'not-allowed' }} />
              </Grid>
            </Grid>

            <Grid container spacing={40} >
              <Grid item md={4}>
              <Typography variant="h6" style={{ marginBottom: '16px' }}>Endereço</Typography>

              <FormControl fullWidth={true}>
                <TextField label={'CEP Residencial'} name={'cep'} value={this.state.cep} onChange={this.CEPhandleChange} InputProps={{ inputComponent: CEPMaskCustom }} error={this.state.cepErro} />
              </FormControl>

              <FormControl fullWidth={true}>
                <TextField label={'Endereço'} name={'endereco'} value={this.state.endereco} onChange={this.handleChange} error={this.state.enderecoErro} />
              </FormControl>

              <Grid container spacing={16}>
                <Grid item md={6} style={styles.halfGrid}>
                  <FormControl fullWidth={true}>
                    <TextField label={'Número'} name={'numeroEndereco'} value={this.state.numeroEndereco} onChange={this.handleChange} error={this.state.numeroEnderecoErro} />
                  </FormControl>

                  <FormControl fullWidth={true}>
                    <TextField label={'Complemento'} name={'complemento'} value={this.state.complemento} onChange={this.handleChange} />
                  </FormControl>

                </Grid>
              </Grid>

              <FormControl fullWidth={true}>
                <TextField label={'Bairro'} name={'bairro'} value={this.state.bairro} onChange={this.handleChange} error={this.state.bairroErro} />
              </FormControl>

              <Grid container spacing={8}>
                <Grid item md={6} style={styles.halfGrid}>
                  <FormControl fullWidth={true}>
                    <TextField label={'Cidade'} name={'cidade'} value={this.state.cidade} onChange={this.handleChange} error={this.state.cidadeErro} />
                  </FormControl>

                  <FormControl fullWidth={true}>
                    <TextField label={'UF'} name={'uf'} value={this.state.uf} onChange={this.handleChange} error={this.state.ufErro} />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

              <Grid item md={4}>
                <Typography variant="h6" style={{ marginBottom: '16px' }}>Contato</Typography>
                <FormControl fullWidth={true}>
                  <TextField type="email" label={'E-mail Pessoal'} name={'emailPessoal'} value={this.state.emailPessoal} onChange={this.handleChange} error={this.state.emailPessoalErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <TextField label={'Celular'} name={'celular'} value={this.state.celular} onChange={this.handleChange} InputProps={{ inputComponent: CelMaskCustom }} />
                    </FormControl>

                    <FormControl fullWidth={true}>
                      <TextField label={'Telefone Residencial'} name={'telefone'} value={this.state.telefone} onChange={this.handleChange} InputProps={{ inputComponent: TelMaskCustom }} error={this.state.telefoneErro} />
                    </FormControl>

                  </Grid>
                </Grid>

            </Grid>
            </Grid>

            

            <Grid style={{ marginTop: '2em' }} container={true} direction="row" justify="center" alignItems="center">
              <Button color="primary" variant="contained" onClick={this.validaForm}>Salvar</Button>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    );
  }
}

export default Form;








